<template>
    <div class="animated fadeIn">
      <mensagem></mensagem>
      <b-row v-if="!loadingItens && items.length <= 0">
        <b-col lg="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong> Pesagens </strong>
              <div class="card-header-actions">
              </div>
            </div>
            <div>
              <b-jumbotron header="Nenhuma pesagem registrada" >
  
              </b-jumbotron>
            </div>
          </b-card>
        </b-col>
      </b-row>
          <b-row>
        <b-col lg="12">
            <grid-pesagem
              :table-data="items" 
              :total-de-paginas="totalDePaginas"
              :action-buttom="true"
              :loading="loadingItens"
              :fields="fields" 
              caption=" Pesagens"
              @paginacao="paginacao"
              @table-remove="removerRegistro"
              @negar-exclusao="negarExclusao"
              @aprovar-exclusao="aprovarExclusao" >
            </grid-pesagem>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import GridPesagem from '@/views/Pesagem/GridPesagem'
  import Mensagem from '@/base/components/Mensagem'
  
  export default {
    name: 'lista-pesagem',
    components: {
        GridPesagem,
      Mensagem
    },
    data(){
      return {
        items: [],
        loadingItens: false,
        totalDePaginas: 1,
        fields: [
          {key: 'dataCadastro', label: 'Data', sortable: true},
          {key: 'centroDeCusto.descricao', label: 'Centro De Custo', sortable: true},
          {key: 'peso', label: 'Peso', sortable: true},
          {key: 'status', label: 'Status', sortable: true},
          {key: 'usuario', label: 'Usuario', sortable: true},
          {key: 'acoes', label: "Ações", sortable: false, thClass: "center, wd-120-px"}
        ],
      }
    },
    beforeMount(){
      this.getGridData(this.$route.params.id)
    },
    methods: {
      removerRegistro(registro){
        var vm = this
        vm.loadingItens = true
        var viewModel = {
            ContaId: vm.$store.getters.getAutenticacao.contaId,
            ClienteId: vm.$store.getters.getAutenticacao.clienteId,
            UsuarioId: vm.$store.getters.getAutenticacao.usuarioId,
            RegistroId: registro.id,
            Justificativa: registro.Justificativa
        }
        //console.log(viewModel)

        this.$http({url: '/pesagem/excluir', data: viewModel, method: 'POST'  })
          .then(response => {
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "Exclusão solicitada!"})
            vm.$router.go()
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            vm.$router.go()
        })
      },
      negarExclusao(registro){
        var vm = this
        this.$http({url: '/pesagem/negar/'+registro.id +'/'+ vm.$store.getters.getAutenticacao.usuarioId, method: 'PUT'  })
          .then(response => {
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "A exclusão solicitada foi negada"})
            vm.$router.go()
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            vm.$router.go()
        })
      },
      aprovarExclusao(registro){
        var vm = this
        this.$http({url: '/pesagem/aprovar/'+registro.id +'/'+ vm.$store.getters.getAutenticacao.usuarioId, method: 'PUT'  })
          .then(response => {
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "A exclusão solicitada foi aprovada"})
            vm.$router.go()
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            vm.$router.go()
        })
      },
      getGridData(pagina){
        var vm = this
        vm.loadingItens = true
        this.$http({url: '/pesagem/' +  pagina + "/" + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
          .then(response => {
            vm.loadingItens=false
            vm.items =  response.data.listagem
            vm.totalDePaginas =response.data.paginas
  
        })
        .catch(err => {
            alert(err.message)
        })
      },    
      paginacao(ev){
        this.getGridData(ev)
      },
    },
  }
  </script>
  